export const COOKIE_CONSENT_NAME = 'cookie-consent'
